import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../AuthContext';

const Navbar = () => {
  const { user, setUser } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [navOpen, setNavOpen] = useState(false);

  const handleLogout = () => {
    setUser(null);
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    navigate('/');
  };

  // Don't show nav links if not authenticated or on login page
  if (!user || location.pathname === '/') {
    return (
      <header className="navbar-header navbar-header-simple" style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
        <div className="navbar-logo-container" style={{ minWidth: 220, display: 'flex', alignItems: 'center' }}>
          <img src="https://www.intmavens.com/wp-content/uploads/2022/09/logo-300x180.png" alt="IntMavens Logo" className="navbar-logo" />
          <span className="navbar-title">IntMavens</span>
        </div>
        <div className="navbar-center-title" style={{ flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center', minWidth: 0 }}>
          <span className="navbar-center-text" style={{ fontWeight: 600, fontSize: '1.5rem', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>Intmavens InfoGrid</span>
        </div>
        {/* Username display for not logged in */}
        <div style={{ minWidth: 220, textAlign: 'right', color: '#555', fontWeight: 500 }}>
          {user ? `Logged in as: ${user.username || user.name || user.email || ''}` : 'Not logged in'}
        </div>
      </header>
    );
  }

  return (
    <header className="navbar-header">
      <div className="navbar-logo-container">
        <img src="https://www.intmavens.com/wp-content/uploads/2022/09/logo-300x180.png" alt="IntMavens Logo" className="navbar-logo" />
        <span className="navbar-title">IntMavens</span>
      </div>
      <div className="navbar-center-title">
        <span className="navbar-center-text">Intmavens InfoGrid</span>
      </div>
      <button
        className="navbar-toggle"
        type="button"
        aria-label="Toggle navigation"
        aria-expanded={navOpen}
        onClick={() => setNavOpen(o => !o)}
      >
        {navOpen ? '-' : '+'}
      </button>
      <nav>
        <ul className={`navbar-links${navOpen ? ' open' : ''}`}>
          <li style={{ display: 'flex', flexDirection: 'row', alignItems: 'center',justifyContent:'center', minWidth: 180, marginLeft: 12 }}>
            <button
              onClick={() => {
                setNavOpen(false);
                handleLogout();
              }}
              className="logout-btn"
              type="button"
              style={{ marginRight: '2px' }}
            >
              Logout
            </button>
          </li>
        </ul>
      </nav>
      <style>{`
@media (max-width: 900px) {
  .navbar-links {
    flex-direction: column;
  }
}
      `}</style>
    </header>
  );
};

export default Navbar;